import {FC, ReactNode} from 'react';
//mui
import {Box} from '@mui/material';
//components
import Button from '@/shared/components/Button';
//constants
import {SKIP_STEP, TEXT} from '@/utils/constants';
//styles
import {stepperActionsStyle} from './StepperActions.styles';

type StepperActionsProps = {
	title: string;
	nextClickHandler: () => void;
	skipClickHandler: () => void;
	nextDisabled?: boolean;
	icon?: ReactNode;
};

const StepperActions: FC<StepperActionsProps> = ({title, skipClickHandler, nextClickHandler, nextDisabled, icon}) => {
	return (
		<Box sx={stepperActionsStyle.wrapper}>
			<Button
				title={SKIP_STEP}
				variant={TEXT}
				sx={stepperActionsStyle.buttonSkip}
				onClick={skipClickHandler}
				disableRipple
			/>

			<Button
				onClick={nextClickHandler}
				title={title}
				endIcon={icon}
				sx={stepperActionsStyle.buttonNext}
				disabled={nextDisabled}
			/>
		</Box>
	);
};

export default StepperActions;
